import axios from "axios";
export type { AxiosResponse } from "axios";
import { cacheAdapterEnhancer } from "axios-extensions";

import { useUserStoreHook } from "@/stores/user";

const baseURL = import.meta.env.VITE_API_BASE_URL;

declare module "axios" {
  export interface AxiosRequestConfig {
    notShowError?: boolean; // 可选参数，用于控制是否显示错误信息
  }
}

declare global {
  interface Window {
    process: any;
  }
}

window.process = { ...window.process, env: { LOGGER_LEVEL: "warn" } };
const service = axios.create({
  baseURL,
  timeout: 30000, // 设置统一的超时时间
  adapter: cacheAdapterEnhancer(axios.getAdapter(axios.defaults.adapter), {
    enabledByDefault: false,
  }),
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = useUserStoreHook().getToken;
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let hasShownLogoutAlert = false;

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data.code !== 200) {
      handleErrorResponse(data, response.config);
      return Promise.reject({
        message: data.message || "Error",
        status: data.code,
      });
    }

    return data; // 成功返回响应数据
  },
  (error) => {
    handleNetworkError(error);
    return Promise.reject(error);
  }
);

// 处理业务错误
function handleErrorResponse(data: any, config: any) {
  if (data.code === 401 && !hasShownLogoutAlert) {
    hasShownLogoutAlert = true;

    ElMessageBox.confirm(
      "您的登录已过期，请重新登录",
      "重新登录",
      {
        confirmButtonText: "重新登录",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        showCancelButton: false,
      }
    )
      .then(() => {
        useUserStoreHook().loginOut();
      })
      .finally(() => {
        hasShownLogoutAlert = false;
      });
  } else if (!config.notShowError) {
    ElMessage.error(data.message || "请求失败");
  }
}

// 处理网络错误
function handleNetworkError(error: any) {
  if (error.config?.notShowError) {
    return;
  }

  let msg = "请求失败";
  if (error.response) {
    const { status, data } = error.response;
    msg = data?.msg || `请求失败，状态码: ${status}`;
    console.error(`状态码: ${status}`);
  } else if (error.message) {
    msg = error.message;
  }

  ElMessage.error(msg);
}

export default service;
